import 'css-chunksrc/client/pages/documentsPage/documentsPage/dropZone/styles.scss';export default {};